var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alert.message)?_c('div',{class:'alert ' + _vm.alert.type},[_vm._v("\n  "+_vm._s(_vm.alert.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }